import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AppConfig} from '../shared/app-config';
import {catchError, map} from 'rxjs/operators';
import {AuditBulkEditTemplateComponentContent} from '../model/audit-bulk-edit-template-component-content';
import {factory} from '../shared/app-logging';
import {throwError} from 'rxjs';
import {ErrorDataService} from './error-data.service';

const logger = factory.getLogger('AuditBulkEditTemplateComponentContentsService');

@Injectable({
  providedIn: 'root'
})
export class AuditBulkEditTemplateComponentContentsService {

  constructor(private httpClient: HttpClient) {
  }

  startBulkEditAuditSession(audit: AuditBulkEditTemplateComponentContent) {
    logger.trace('startBulkEditAuditSession called');
    return this.httpClient.post(environment.contentLibraryApiBaseUrl + AppConfig.urlAuditBulkEditTCC, audit).pipe(map(
      response => {
        logger.debug(JSON.stringify(response));
        if (response['code'] === 200) {
          logger.info('Bulk edit audit session started');
          return AuditBulkEditTemplateComponentContent.parse(response['data']);
        }
      }
    ), catchError((err: Error | HttpErrorResponse) => {
      const message = `In AuditBulkEditTemplateComponentContentsService.startBulkEditAuditSession(${audit}).`;
      return throwError(ErrorDataService.overLoadError(err, message));
    }));
  }

  endBulkEditAuditSession(audit: AuditBulkEditTemplateComponentContent) {
    logger.trace('endBulkEditAuditSession called');
    return this.httpClient.put(environment.contentLibraryApiBaseUrl + AppConfig.urlAuditBulkEditTCC, audit).pipe(map(
      response => {
        logger.debug(JSON.stringify(response));
        if (response['code'] === 200) {
          logger.info('Bulk edit audit session ended');
          return AuditBulkEditTemplateComponentContent.parse(response['data']);
        }
      }
    ), catchError((err: Error | HttpErrorResponse) => {
      const message = `In AuditBulkEditTemplateComponentContentsService.endBulkEditAuditSession(${audit}).`;
      return throwError(ErrorDataService.overLoadError(err, message));
    }));
  }
}
